import React from "react";
// Components
import { Grid } from "@mui/material";
import { DatePickerField, InputTextField } from "components/UI";
import { API_LOG_MONITORING } from "shared/constants";

export default function SubCriterialBar(props) {
  const { searchForm, setSearchForm } = props;
  return (
    <React.Fragment>
      <Grid item xs={3} style={{ display: "flex" }}>
        <strong style={{ margin: "auto 0px", width: "90px" }}>User ID : </strong>
        <InputTextField
          id="input_userId"
          fullWidth={true}
          value={searchForm?.userId}
          tabIndex={0}
          onChange={e =>
            setSearchForm(prev => ({
              ...prev,
              [API_LOG_MONITORING.USER_ID]: e.target.value,
            }))
          }
        />
      </Grid>
      <Grid item xs={2} style={{ display: "flex" }}>
        <strong style={{ margin: "auto 10px", width: "105px" }}>App ID : </strong>
        <InputTextField
          id="input_appId"
          fullWidth={true}
          value={searchForm?.appId}
          tabIndex={0}
          onChange={e =>
            setSearchForm(prev => ({
              ...prev,
              [API_LOG_MONITORING.APP_ID]: e.target.value.trim(),
            }))
          }
          regularExp={/^[a-zA-Z0-9_*-]*$/}
        />
      </Grid>
      <Grid item xs={3} style={{ display: "flex" }}>
        <strong style={{ margin: "auto 10px", width: "80px" }}>From : </strong>
        <DatePickerField
          id="input_dateFrom"
          value={searchForm?.dateFrom}
          fullWidth={true}
          style={{ minWidth: "300px" }}
          tabIndex={0}
          onChange={date => {
            setSearchForm(prev => ({
              ...prev,
              [API_LOG_MONITORING.DATE_FORM]: date,
            }));
          }}
        />
      </Grid>
      <Grid item xs={3} style={{ display: "flex" }}>
        <strong style={{ margin: "auto 10px", width: "80px" }}>To : </strong>
        <DatePickerField
          id="input_dateTo"
          fullWidth={true}
          value={searchForm?.dateTo}
          tabIndex={0}
          onChange={date =>
            setSearchForm(prev => ({
              ...prev,
              [API_LOG_MONITORING.DATE_TO]: date,
            }))
          }
        />
      </Grid>
    </React.Fragment>
  );
}
